import {useState, useMemo} from "react";
import Text from "../../components/Text";
import SearchBox from "../../components/SearchBox";
import { Col, Row } from "../../components/Flexbox";
import { useTheme } from "../../scripts/functions/ThemeProvider";
import { payroll } from "../../data/DummyPayrolls";
import CustomerRow from "../../components/CustomerRow";
import Dropdown from "../../components/Dropdown";
import { MenuItem } from "@mui/material";
import {PAYROLL_TYPES, payrollDates, filterPayroll } from "../../containers/PayrollNormalizer";

const formatCurrency = (val) => val?.toLocaleString('es-MX', {style: 'currency', currency: 'MXN'})

const DetailRow = ({label, value, isNeg, theme, bold}) => (
    <Row style={{justifyContent: 'space-between', width: '100%', maxHeight: 'max-content'}}>
        <Text size={15} color={isNeg ? theme.Magenta : theme.ONED} weight={bold ? 'bold' : 'normal'}>{isNeg ? `- ${label}` : label}</Text>
        <Text size={15} color={theme.ONED} weight={bold ? 'bold' : 'normal'}>
            {isNeg ? `(${formatCurrency(value)})` : formatCurrency(value)}
        </Text>
    </Row>
)
const MostrarNominas = () => {

    const {theme} = useTheme();     
    const [nomina, setNomina] = useState(null)

    //Modifica el estilo de los Text de la lista
    const [active, setActive] = useState(null);
    const [hover, setHover] = useState(null);    

    //Filtrado
    const [search, setSearch] = useState("");
    const [selectDate, setSelectDate] = useState("");
    const [selectedPayroll, setSelectedPayroll] = useState("");

    const filteredData = useMemo(() => {
        console.log("Filters:", { selectDate, selectedPayroll, search });
        return filterPayroll(payroll, selectDate, selectedPayroll, search)
    }, [selectDate, selectedPayroll, search])
    
    return(
        <Row style={{ width:'100%', height: '100%'}}>
            <style>
                {`
                    ::-webkit-scrollbar {display: none;}
                `}
            </style>
            <Col style={{paddingLeft:64, height: '100%', overflow: 'hidden'}}>
                <Row style={{marginTop:20, justifyContent: 'space-between', width: '100%', maxHeight: 'max-content'}}>
                    <Row style={{gap: 16, flexWrap: 'wrap', justifyContent: 'start'}}>
                        <Dropdown theme={theme} value={selectedPayroll} onChange={(value) => setSelectedPayroll(value)} placeholder = "Selecciona el tipo" style={{width: 160, height: 36}}>
                            <MenuItem value="">Selecciona el tipo</MenuItem>
                            {PAYROLL_TYPES.map(type => (
                                <MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>
                            ))}
                        </Dropdown>
                        <Dropdown theme={theme} value={selectDate} onChange={(value) => setSelectDate(value)} placeholder = "Selecciona la fecha" style={{width: 160, height: 36}}>
                            <MenuItem value="">Selecciona la fecha</MenuItem>
                            {payrollDates.map(date => (
                                <MenuItem key={date.value} value={date.value}>{date.label}</MenuItem>
                            ))}
                        </Dropdown>
                    </Row>
                    <Row style={{gap: 16, flexWrap: 'wrap', alignItems: 'center', justifyContent: 'flex-end', paddingRight: 10}}>
                        <Text style={{ cursor:'pointer', transition:'transform 2s ease', paddingRight: 10}}  color={theme.Magenta}  size={15}>Exportar</Text>
                        <SearchBox theme={theme} value = {search} onChange={setSearch} style={{width: 168, height: 36}}/>
                    </Row>
                </Row>
                <Col style={{marginTop: 20, width: '100%', paddingRight: 10, overflowY: 'auto', minHeight: 0, justifyContent: 'start'}}>
                    {filteredData.map(emp => {
                        const isActive = emp.id === active;
                        const isHover = emp.id === hover;
                        return(
                            <CustomerRow
                                key = {emp.id}
                                data = {emp}
                                isActive = {isActive}
                                isHover = {isHover}
                                onClick={() => {setActive(emp.id); setNomina(emp);}}
                                onMouseEnter={() => setHover(emp.id)}
                                onMouseLeave={() => setHover(null)}
                                theme = {theme}
                            />
                        )
                    })}
                </Col>
            </Col>
            <Col style={{backgroundColor: theme.Ed, padding: '25px 64px 25px 33px', height: '100%', alignItems: 'start', justifyContent: 'start'}}>
                {nomina ? (
                    <>
                        <Text size={32} color={theme.ONED}>{nomina.nombre}</Text>
                        <Text size={15} color={theme.ONED} style={{ marginTop: 8 }}>{nomina.puesto}</Text>

                        <Col style={{ width: '100%', gap: 48, marginTop: 33, alignItems: 'start', justifyContent: 'start'}}>
                            <Col style={{ width: '100%', gap: 17, maxHeight: 'max-content'}}>
                                <DetailRow label="Sueldo base" value={nomina.sueldoBase} bold theme={theme} />
                                <Col style={{ gap: 12, paddingLeft: 32, width: '100%' }}>
                                    <DetailRow label={`+ Tiempo extra (${nomina.tiempoExtra.horas} hrs)`} value={nomina.tiempoExtra.valor} theme={theme} />
                                    <DetailRow label="+ Bono Producción (5%)" value={nomina.bonoProd} theme={theme} />
                                    <DetailRow label="+ Bono Puntualidad y Asistencia" value={nomina.bonoPuntAsis} theme={theme} />
                                    <DetailRow label="+ Bono EBIDTA (0%)" value={nomina.bonoEBIDTA} theme={theme} />
                                    <DetailRow label={`Faltas (${nomina.faltas.numFaltas})`} value={nomina.faltas.valor} isNeg theme={theme} />
                                    <DetailRow label={nomina.prestamo.nombre} value={nomina.prestamo.valor} isNeg theme={theme} />
                                </Col>
                            </Col>

                            <Col style={{ width: '100%', gap: 9, maxHeight: 'max-content' }}>
                                <DetailRow label="Total extras" value={nomina.totalExtras} theme={theme} />
                                <DetailRow label="Total descuentos" value={nomina.totalDescuentos} isNeg theme={theme} />
                                <DetailRow label="Gran total" value={nomina.granTotal} bold theme={theme} />
                            </Col>

                            <Col style={{ alignItems: 'start', gap: 9, maxHeight: 'max-content' }}>
                                <Text style={{ cursor: 'pointer' }} color={theme.Magenta} size={15}>Registro de asistencia</Text>
                                <Text style={{ cursor: 'pointer' }} color={theme.Magenta} size={15}>Historial de vacaciones y movimientos</Text>
                            </Col>
                        </Col>
                    </>
                ) : (
                    <Text color={theme.ONED} size={15}>Selecciona una nómina para ver sus detalles</Text>
                )}
            </Col>
        </Row>
    )
}

export default MostrarNominas;